import { render, staticRenderFns } from "./SectionLoader.vue?vue&type=template&id=901f21d8&scoped=true&"
import script from "./SectionLoader.vue?vue&type=script&lang=js&"
export * from "./SectionLoader.vue?vue&type=script&lang=js&"
import style0 from "./SectionLoader.vue?vue&type=style&index=0&id=901f21d8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901f21d8",
  null
  
)

export default component.exports